<template>
  <CollapsiblePanel
    :label="
      $t('_web_tournament_settings_promotional-options', 'Promotional options')
    "
    class="promotional-title"
    :variant="['default', 'rounded', '30-12-paddings']"
  >
    <div class="tournament-creation-promotion-section">
      <div class="row mb-5 tournament-promotion-type">
        <TournamentSettingRegistrationType class="col-3" />
        <div class="col-4 countries-restriction">
          <TournamentSettingCountriesRestriction />
        </div>
        <div class="col-4 tournament-country">
          <TournamentSettingCountry />
        </div>
      </div>
      <div class="row mb-5 promo-logo-video">
        <div class="col-3">
          <TournamentSettingLogo />
        </div>
        <div class="col-6">
          <TournamentSettingPromoVideo />
        </div>
      </div>
      <div class="row">
        <div class="mb-5 organizer-sponsor-logos col-3">
          <Subheader
            :text="
              $t('_web_tournament_event_organizer-logo-label', 'Organizer logo')
            "
          />
          <div class="row">
            <TournamentSettingOrganizerName />
          </div>
          <div class="row mt-5 logo-org">
            <TournamentSettingOrganizerLogo />
          </div>
        </div>
        <div class="d-flex flex-column mb-5 default-sponsor-logo col-7">
          <Subheader
            :text="$t('_web_tournament_sponsor-logos-label', 'Sponsor logos')"
          />
          <TournamentSettingSponsors class="logo-sponsor" />
        </div>
      </div>
    </div>
  </CollapsiblePanel>
</template>

<script>
import { translate } from '@/mixins/translate';
import CollapsiblePanel from '@/components/atoms/CollapsiblePanel';
import TournamentSettingLogo from '@/views/tournaments/management/singleTournament/components/SettingsLogo';
import TournamentSettingPromoVideo from '@/views/tournaments/management/singleTournament/components/SettingsPromoVideo';
import TournamentSettingSponsors from '@/views/tournaments/management/singleTournament/components/SettingsSponsors';
import TournamentSettingOrganizerName from '@/views/tournaments/management/singleTournament/components/SettingsOrganizerName';
import TournamentSettingOrganizerLogo from '@/views/tournaments/management/singleTournament/components/SettingsOrganizerLogo';
import TournamentSettingRegistrationType from '@/views/tournaments/management/singleTournament/components/SettingsRegistrationType';
import TournamentSettingCountriesRestriction from '@/views/tournaments/management/singleTournament/components/SettingsCountriesRestriction';
import Subheader from '@/components/atoms/Subheader';
import TournamentSettingCountry from '@/views/tournaments/management/singleTournament/components/SettingsCountry';
export default {
  name: 'PromotionSection',
  components: {
    CollapsiblePanel,
    TournamentSettingLogo,
    TournamentSettingPromoVideo,
    TournamentSettingSponsors,
    TournamentSettingOrganizerName,
    TournamentSettingOrganizerLogo,
    TournamentSettingRegistrationType,
    TournamentSettingCountriesRestriction,
    TournamentSettingCountry,
    Subheader,
  },
  mixins: [translate('_web_tournament_settings')],
};
</script>
<style lang="scss">
.tournament-creation-promotion-section {
  padding: 13px;
}

.promotional-title :nth-child(1) h4 > span {
  font-size: $hr-heading-5 !important;
}

.tournament-promotion-type label {
  padding-bottom: 15px;
  font-size: $hr-text-small !important;
  font-weight: 600;
}

.tournament-promotion-type input {
  background-color: $hr-bg-header;
  border: 2px solid transparent;
  width: 70% !important;
}

.tournament-country .autosuggest_clear-icon {
  margin: 10px 125px 0px 0px;
  @media only screen and (max-width: 1875px) {
    margin: 30px 125px 0px 0px;
  }
  .app-rtl & {
    margin: 30px 0px 0px 110px;
  }
  @media only screen and (max-width: 1645px) {
    .app-rtl & {
      margin: 50px 0px 0px 110px;
    }
  }
  @media only screen and (min-width: 1790px) {
    .app-rtl & {
      margin: 4px 0px 0px 120px !important;
    }
  }
}

.countries-restriction .autosuggest_clear-icon {
  margin: 10px 125px 0px 0px !important;
  .app-rtl & {
    margin: 45px 0px 0px 0px !important;
    padding-left: 70px !important;
  }
  @media only screen and (max-width: 1875px) {
    margin: 30px 125px 0px 0px !important;
  }
  @media only screen and (min-width: 1822px) {
    .app-rtl & {
      margin: 30px 0px 0px 0px !important;
      padding-left: 70px !important;
    }
  }
}

.tournament-promotion-type .segment-control-btn {
  background-color: $hr-bg-header;
}

.countries-restriction .playhera-icon {
  margin-right: 317px;
  .app-rtl & {
    margin-left: 55px !important;
  }
}

.tournament-country .align-top {
  margin-right: 285px;
  .app-rtl & {
    margin-left: 55px;
  }
}

.promo-logo-video label {
  padding-bottom: 15px;
  font-size: $hr-text-small !important;
  font-weight: 600;
}

.organizer-sponsor-logos {
  width: 50% !important;
}

.organizer-sponsor-logos label {
  padding-bottom: 15px;
  font-size: $hr-text-regular !important;
  font-weight: 600;
}

.organizer-sponsor-logos input {
  background-color: $hr-bg-header;
  border: 2px solid transparent;
  width: 12rem !important;
}

.organizer-sponsor-logos .organizer-logo {
  width: 10rem !important;
}

.logo-org {
  width: 80rem !important;
}

.default-sponsor-logo label {
  padding-bottom: 15px;
  font-size: $hr-text-regular !important;
  font-weight: 600;
  padding-top: 15px;
}

.default-sponsor-logo input {
  background-color: $hr-bg-header;
  border: 2px solid transparent;
}

.logo-sponsor .add-country {
  margin-top: 45px;
}

.logo-sponsor .add-country-row {
  margin-top: -3rem !important;
  padding-bottom: 40px;
}

.logo-sponsor .logo-item {
  padding-bottom: 10px;
}

.logo-sponsor .country-logos :nth-child(3) {
  margin-right: -30px !important;
  padding-top: 20px;
}

.logo-sponsor .autosuggest_clear-icon {
  margin: 30px -10px 0px 0px !important;
}
</style>
